import addStylesheet from '@/utils/addStylesheet'
import { generateCSSFromConfig } from '@/utils/cssGenerator'
import { FILTERS } from '@/enum/Filters'

export default function enableContrast(contrast: string | false) {
  const filter = contrast ? FILTERS[contrast] : undefined

  if (!filter) {
    // Remove styles if no contrast is set
    document.getElementById('asw-filter-style')?.remove()
    document.documentElement.classList.remove('asw-filter')
    return
  }

  const css = generateCSSFromConfig({
    ...filter,
    selector: 'html.asw-filter',
  })

  addStylesheet({ css, id: 'asw-filter-style' })
  document.documentElement.classList.add('asw-filter')
}
